import { createSlice } from "@reduxjs/toolkit";

export const FILTROS_PADRAO = {
  nivel: 4,
  ncm: "",
  produto: "",
  fornecedor: "",
  mostrarZerados: false,
};

const initialState = () => ({
  issueDateStart: null,
  issueDateEnd: null,
  filters: { ...FILTROS_PADRAO },
});

export const icmsNcmSlice = createSlice({
  name: "icmsNcm",
  initialState,
  reducers: {
    handleChangeDate: (state, { payload }) => {
      state.issueDateStart = payload.issueDateStart;
      state.issueDateEnd = payload.issueDateEnd;
    },
    handleAddFilter: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
    },
    handleCleanFilters: state => {
      state.filters = { ...FILTROS_PADRAO };
    },
  },
});

export const { handleChangeDate, handleAddFilter, handleCleanFilters } =
  icmsNcmSlice.actions;

export default icmsNcmSlice.reducer;
